/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"

export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

export type ProjectKpiFragment = {
  __typename: "ProjectKpi"
  id: string
  projectsCount: {
    __typename: "ProjectsCount"
    total: number
    dailyOverview?: {
      __typename: "ProjectsDailyOverview"
      last7: number
      last30: number
    } | null
  }
}

export type UserKpiFragment = {
  __typename: "UserKpi"
  id: string
  usersCount: {
    __typename: "UsersCount"
    total: number
    internal: number
    external: number
  }
  registrations: {
    __typename: "Registrations"
    total: number
    linkedin: number
    microsoft: number
    google: number
    email: number
  }
  activeUsers: { __typename: "ActiveUsers"; external: number }
  dailyOverview: {
    __typename: "UsersDailyOverview"
    external: {
      __typename: "ExternalUsersDailyOverview"
      last7: {
        __typename: "ExternalUsersDailyOverviewLastDays"
        logins: number
        signups: number
      }
      last30: {
        __typename: "ExternalUsersDailyOverviewLastDays"
        logins: number
        signups: number
      }
    }
  }
}

export const ProjectKpiFragmentDoc = gql`
  fragment ProjectKpi on ProjectKpi {
    id
    projectsCount {
      total
      dailyOverview {
        last7
        last30
      }
    }
  }
`
export const UserKpiFragmentDoc = gql`
  fragment UserKpi on UserKpi {
    id
    usersCount {
      total
      internal
      external
    }
    registrations {
      total
      linkedin
      microsoft
      google
      email
    }
    activeUsers {
      external
    }
    dailyOverview {
      external {
        last7 {
          logins
          signups
        }
        last30 {
          logins
          signups
        }
      }
    }
  }
`
